export var ReferenceTableTag;
(function (ReferenceTableTag) {
    ReferenceTableTag["SPECIES"] = "Species";
    ReferenceTableTag["STATUS"] = "Status";
    ReferenceTableTag["CONDITION"] = "Condition";
    ReferenceTableTag["GROWING_SPACE"] = "GrowingSpace";
    ReferenceTableTag["LAND_USE"] = "LandUse";
    ReferenceTableTag["OBSERVATIONS"] = "Observations";
    ReferenceTableTag["OBSERVATIONS_ABIOTIC"] = "ObservationsAbiotic";
    ReferenceTableTag["OBSERVATIONS_BIOTIC"] = "ObservationsBiotic";
    ReferenceTableTag["OBSERVATIONS_CHARACTERISTICS"] = "ObservationsCharacteristics";
    ReferenceTableTag["TREE_WORK"] = "TreeWork";
    ReferenceTableTag["CLEARANCE_CONFLICTS"] = "ClearanceConflicts";
    ReferenceTableTag["RISK_PART"] = "RiskPart";
    ReferenceTableTag["RISK_FAILURE"] = "RiskFailure";
    ReferenceTableTag["RISK_IMPACT"] = "RiskImpact";
    ReferenceTableTag["RISK_LIKELIHOOD"] = "RiskLikelihood";
    ReferenceTableTag["RISK_CONSEQUENCE"] = "RiskConsequence";
    ReferenceTableTag["RISK_RATING"] = "RiskRating";
    ReferenceTableTag["RISK_TARGET"] = "RiskTarget";
})(ReferenceTableTag || (ReferenceTableTag = {}));
//# sourceMappingURL=reference-table.interface.js.map